export const RESET_PASSWORD_RESET_STATE_KEY = 'resetPasswordReset'
export const FORM_RESET_PASSWORD_RESET = 'formResetPasswordReset'

export const CONTENT_LOAD = 'Casino/ResetPasswordReset/LOAD'
export const CONTENT_LOAD_SUCCESS = 'Casino/ResetPasswordReset/LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Casino/ResetPasswordReset/LOAD_ERROR'
